export type RangeFilterValue = [number | undefined, number | undefined];

export function getNextRangeFilterValue(
  oldValue: RangeFilterValue | undefined,
  index: 0 | 1,
  inputValue: string,
) {
  const next: RangeFilterValue = [oldValue?.[0], oldValue?.[1]];

  next[index] = inputValue === '' ? undefined : Number(inputValue);

  return next[0] == null && next[1] == null ? undefined : next;
}
